"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTS = void 0;
const CONSTS = exports.CONSTS = Object.freeze({
  // アクション名のプロジェクト共通接頭辞
  COMMON_ACTION_PREFIX: 'pande',
  // 明細更新情報のキー名
  DETAIL_UPDATE_INFO_KEY: {
    // 勤務場所・立ち入り場所
    WORKSTATUS_ENTRYPLACE: 'workstatusEntryplace',
    // 濃厚接触可能性者情報（NECg社員）
    CLOSECONTACT_NECG: 'closecontactNecg',
    // 濃厚接触可能性者情報（派遣・請負）
    CLOSECONTACT_OTHER: 'closecontactOther',
    // 濃厚接触可能性者情報（顧客）
    CLOSECONTACT_CUSTOMER: 'closecontactCustomer',
    // 報告者・同報先情報
    BROADCAST: 'broadcast',
    // 座席表
    SHEET_MAP: 'sheetMap',
    // 添付ファイル
    ATTACHED_FILE: 'attachedFile'
  }
});